import type { WebContainer } from '@webcontainer/api';

/** Prefer `npm ci` when lockfile is present — faster, repeatable installs vs resolver. */
export function npmFrozenInstallCliArgs(workspaceHasPackageLock: boolean): string[] {
  return workspaceHasPackageLock
    ? ['ci', '--no-fund', '--no-audit']
    : ['install', '--no-fund', '--no-audit'];
}

/** True if `path` exists in the WebContainer virtual FS (UTF-8 read attempt). */
export async function webcontainerFileExistsUtf8(wc: WebContainer, path: string): Promise<boolean> {
  try {
    await wc.fs.readFile(path, 'utf-8');
    return true;
  } catch {
    return false;
  }
}
